import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  Paper,
  Skeleton,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { StoreDispatch } from "../redux/reduxStore.ts";
import { addtoCart, removeFromCart } from "../redux/cart/actions.ts";
import {
  getAllProduct,
  getProductsByCategoryId,
} from "../services/product/services.ts";
import { CategoryProductItem, ProductData } from "../services/product/types.ts";
import ProductCardHorizontal from "../commponents/ProductCardHorizontal.tsx";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CartButton from "../commponents/CartButton.tsx";

const styles = {
  headerBox: {
    width: "100%",
    height: { xs: 70, sm: 90 },
    boxShadow: 3,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    backgroundColor: "#b7472a",
  },
  backButton: {
    position: "absolute",
    top: { xs: 20, sm: 30 },
    left: { xs: 15, sm: 20 },
    color: "white",
  },
  headerText: {
    fontWeight: 600,
    color: "white",
    fontFamily: "'Spectral', serif",
    fontSize: { xs: "1.2rem", sm: "1.5rem" },
  },
  container: {
    paddingBottom: 0,
    backgroundColor: "transparent",
  },
  skeleton: {
    borderRadius: 1,
  },
  noProductsText: {
    mt: 2,
    fontFamily: "'Spectral', serif",
  },
  tableHeaderRow: {
    display: "grid",
    gridTemplateColumns: { xs: "3fr 1fr 1fr 1fr 1fr", md: "3fr 1fr 1fr 1fr 1fr" },
    backgroundColor: "#b7472a",
    padding: { xs: "10px", sm: "20px", md: "30px" },
    alignItems: "center",
  },
  tableHeaderCell: {
    fontWeight: "bold",
    color: "white",
    textAlign: "center",
    fontSize: { xs: "0.8rem", sm: "1rem", md: "1.2rem" },
  },
  table: {
    minWidth: 650,
    overflowX: "auto",
    "& td, & th": {
      padding: { xs: "6px", sm: "12px" },
    },
  },
  iconButton: {
    borderRadius: "50%",
    width: { xs: 40, sm: 50 },
    height: { xs: 40, sm: 50 },
    color: "white",
    backgroundColor: "#b7472a",
    fontSize: "0.875rem",
    "&:hover": {
      backgroundColor: "#8E2B1E",
    },
  },
};

const CategoryProduct: React.FC = () => {
  const { id, name } = useParams<{ id: string; name: string }>();
  const navigate = useNavigate();
  const dispatch = useDispatch<StoreDispatch>();
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState<CategoryProductItem[]>([]);

  const addTocart = (product: ProductData) => {
    dispatch(addtoCart({ productData: product, quantity: 1 }))
      .unwrap()
      .then((message) => {});
  };

  const removeQuantity = (product: ProductData) => {
    dispatch(removeFromCart({ productData: product, quantity: 1 }))
      .unwrap()
      .then((message) => {
        // alert(message);
      });
  };

  useEffect(() => {
    setLoading(true);
    if (id === "allProducts") {
      getAllProduct({}).then((data: any) => {
        if (data) setProducts(data.data);
        setLoading(false);
      });
    } else {
      if (id)
        getProductsByCategoryId(id, {})
          .then((data: any) => {
            if (data) setProducts(data.data);
          })
          .catch((err) => console.log(err))
          .finally(() => {
            setLoading(false);
          });
    }
  }, [id]);

  return (
    <>

      {/* Header Section */}
      <Box sx={styles.headerBox}>
        <IconButton sx={styles.backButton} onClick={() => navigate(-1)}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h6" sx={styles.headerText}>

          {name}
        </Typography>
      </Box>

      <Container sx={styles.container}>
        {loading ? (

          <Skeleton variant="rectangular" width={"100%"} height={100} animation="wave" sx={styles.skeleton} />

        ) : products.length === 0 ? (
          <Typography align="center" sx={styles.noProductsText}>
            No Products Found
          </Typography>
        ) : (
          <Box>

            <Box sx={styles.tableHeaderRow}>
              <Box sx={styles.tableHeaderCell}>Product</Box>
              <Box sx={styles.tableHeaderCell}>Price</Box>
              <Box sx={styles.tableHeaderCell}>Quantity</Box>
              <Box sx={styles.tableHeaderCell}>Total</Box>
              <Box sx={styles.tableHeaderCell}>Action</Box>
            </Box>

            {/* Product Table */}
            <TableContainer component={Paper}>
              <Table sx={styles.table} aria-label="simple table">

                <TableBody>
                  {products.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell align="left">
                        <ProductCardHorizontal
                          product={item}
                          src={`https://bootleggersdistribution.net${item?.images[0]?.path}`}
                          onPressAdd={() => addTocart(item)}
                          onPressDec={() => removeQuantity(item)}
                          onDelete={() => removeQuantity(item)}
                          checked={false}
                          onCheck={() => {}}
                          onPress={() => {}}
                        />
                      </TableCell>

                      <TableCell align="center">

                        <IconButton sx={styles.iconButton} onClick={() => addTocart(item)}>

                          <AddIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}
      </Container>
      <CartButton />
    </>
  );
};

export default CategoryProduct;
